// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Dimension/components/BasePlate/styles.scss
// module id = 1282
// module chunks = 0